import { Link } from "react-router-dom";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";

export default function NotFound() {
  useDocumentMeta("妖精网站 - 页面未找到");

  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center px-4 text-center">
      <span className="pointer-events-none absolute bottom-6 select-none font-heading text-9xl font-black text-background-200 md:text-[12rem]">
        404
      </span>
      <div className="relative z-10 flex flex-col items-center">
        <span className="mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-primary-100 text-primary-600">
          <i className="ri-ghost-2-line text-3xl" />
        </span>
        <h1 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          这只妖精飞走了，页面未找到
        </h1>
        <p className="mt-3 max-w-md text-sm text-foreground-500">
          你访问的页面可能已被移除或地址有误，不妨回到首页继续探索妖精影视世界。
        </p>
        <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            返回首页
          </Link>
          <Link
            to="/search"
            className="whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-semibold text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            去搜索作品
          </Link>
        </div>
      </div>
    </div>
  );
}